import React from 'react';
import { Tooltip, useMediaQuery } from '@mui/material';

const HoverTooltip = ({ children, ...props }) => {
    const isTouch = useMediaQuery('(pointer: coarse)');
    if (isTouch) return children;
    return <Tooltip {...props}>{children}</Tooltip>;
};

export default HoverTooltip;
